class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;
		this.scrollLockY = 0;

		this.megaMenuLinks = el.querySelectorAll('.mega-menu-item');
		this.mobileLinks = el.querySelectorAll('.mobile-top-level-link-clickable');
		this.mobileTaxonomyParents = el.querySelectorAll('.mobile-taxonomy-parent-button');
		this.megaMenuBg = document.querySelector('.site-header__megamenu-bg');

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		this.removeSearchValue();
	}

	setupEventHandlers() {
		const body = document.querySelector('body');
		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		// mobile menu handler
		if (this.mobileLinks) {
			this.mobileLinks.forEach((link) => {
				link.addEventListener('click', (e) => {
					e.preventDefault();
					this.mobileLinks.forEach((closeLink) => {
						if (closeLink !== link) {
							closeLink.classList.remove('active');
						}
					});
					link.classList.toggle('active');
				});
			});
		}

		if (this.mobileTaxonomyParents) {
			this.mobileTaxonomyParents.forEach((button) => {
				button.addEventListener('click', (e) => {
					e.preventDefault();
					const parent = button.closest('.mobile-taxonomy-parent');
					if (!parent) {
						return;
					}

					const wrapper = parent.parentElement;
					if (wrapper) {
						wrapper.querySelectorAll('.mobile-taxonomy-parent').forEach((item) => {
							if (item !== parent) {
								item.classList.remove('active');
							}
						});
					}

					parent.classList.toggle('active');
				});
			});
		}

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar(), { passive: true });

		// mega menu handler — click covers mouse + iOS tap
		if (this.megaMenuLinks) {
			this.megaMenuLinks.forEach((link) => {
				link.addEventListener('click', (event) => {
					event.preventDefault();
					event.stopPropagation();
					this.toggleMegaMenu(link, body);
				});
			});
		}

		if (this.megaMenuBg) {
			this.megaMenuBg.addEventListener('click', () => {
				this.closeAllMegaMenus(body);
			});
		}

		document.addEventListener('keydown', (evt) => {
			if (evt.key === 'Escape') {
				this.closeAllMegaMenus(body);
			}
		});
	}

	toggleMegaMenu(link, body) {
		const wrapper = link.closest('.mega-menu-wrapper');
		const isOpen = link.classList.contains('active');

		this.megaMenuLinks.forEach((megaMenuLink) => {
			if (megaMenuLink !== link) {
				megaMenuLink.setAttribute('aria-expanded', 'false');
				megaMenuLink.classList.remove('active');
				const otherWrapper = megaMenuLink.closest('.mega-menu-wrapper');
				if (otherWrapper) {
					otherWrapper.classList.remove('is-open');
				}
			}
		});

		if (isOpen) {
			link.setAttribute('aria-expanded', 'false');
			link.classList.remove('active');
			if (wrapper) {
				wrapper.classList.remove('is-open');
			}
			this.unlockScroll(body);
			if (this.megaMenuBg) {
				this.megaMenuBg.classList.remove('active');
			}
		} else {
			link.setAttribute('aria-expanded', 'true');
			link.classList.add('active');
			if (wrapper) {
				wrapper.classList.add('is-open');
			}
			this.lockScroll(body);
			if (this.megaMenuBg) {
				this.megaMenuBg.classList.add('active');
			}
		}
	}

	closeAllMegaMenus(body) {
		this.megaMenuLinks.forEach((megaMenuLink) => {
			megaMenuLink.setAttribute('aria-expanded', 'false');
			megaMenuLink.classList.remove('active');
			const wrapper = megaMenuLink.closest('.mega-menu-wrapper');
			if (wrapper) {
				wrapper.classList.remove('is-open');
			}
		});

		this.unlockScroll(body);

		if (this.megaMenuBg) {
			this.megaMenuBg.classList.remove('active');
		}
	}

	/**
	 * iOS-safe scroll lock. overflow:hidden alone freezes nested position:fixed panels.
	 */
	lockScroll(body) {
		if (body.classList.contains('no-scroll')) {
			return;
		}

		this.scrollLockY = window.scrollY || window.pageYOffset || 0;
		body.style.top = `-${this.scrollLockY}px`;
		body.classList.add('no-scroll');
	}

	unlockScroll(body) {
		if (!body.classList.contains('no-scroll')) {
			return;
		}

		body.classList.remove('no-scroll');
		body.style.top = '';
		window.scrollTo(0, this.scrollLockY || 0);
	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
		document.documentElement.style.setProperty('--site-header-height', `${this.headerHeight}px`);
	}

	removeSearchValue() {
		const searchInput = document.getElementById('searchsubmitmobile');
		if (searchInput) {
			searchInput.value = '';
		}
	}
}

export default SiteHeader;
